<!-- <nav class="navbar container">
  <div class="header-landing row align-items-center justify-content-between">
    <a class="header-left" routerLinkActive="active" routerLink="/home">
      <img src="/assets/theme/resources/images/landing-page/icon-logo.png" class="img-res">
      <div class="caption-logo">
        <h4>{{ 'PangJangFreightMarketplace' | translate }}</h4>
        <p>{{ 'Slogan' | translate }}</p>
      </div>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse header-right" id="navbarNavDropdown">
      <ul class="menu">
        <li><a routerLinkActive="active" routerLink="/home">{{ 'Home' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/for-buyer">{{ 'ForBuyers' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/for-carrier">{{ 'ForCarriers' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/about">{{ 'AboutUs' | translate }}</a></li>
        <li><a routerLinkActive="active" routerLink="/contact">{{ 'ContactUs' | translate }}</a></li>
      </ul>
     
      <button class="btn btn-sign-in" (click)="goLogin()">{{ 'SignIn' | translate }}</button>
    </div>
  </div>
</nav> -->

<div class="container">
  <div class="header-landing row align-items-center">
    <nav class="col-12 navbar navbar-expand-xl navbar-light justify-content-between pl-0 pr-0">
      <a class="header-left" routerLinkActive="active" routerLink="/home">
        <img src="/assets/theme/resources/images/landing-page/EcCargo280x60.jpg" class="img-responsive" alt="EcCargo Freight Matching Marketplace">
        <div class="caption-logo">          
		  <h1>{{ 'PangJangFreightMarketplace' | translate }}</h1>
          <!--p>{{ 'Slogan' | translate }}</p-->
        </div>		
      </a>
      <button class="navbar-toggler u-hamburger border-0" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <!-- <span class="navbar-toggler-icon"></span> -->
        <span id="hamburgerTrigger" class="u-hamburger__box">
          <span class="u-hamburger__inner"></span>
        </span>
      </button>
      <div class="header-right collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="menu navbar-nav">
          <li class="menu-item mb-3 mb-xl-0 mt-3 mt-xl-0"><a class="" routerLinkActive="active"
              routerLink="/home">{{ 'Home' | translate }}</a></li>
          <li class="menu-item mb-3 mb-xl-0"><a class="" routerLinkActive="active"
              routerLink="/for-buyer">{{ 'ForBuyers' | translate }}</a>
          </li>
          <li class="menu-item mb-3 mb-xl-0"><a class="" routerLinkActive="active"
              routerLink="/for-carrier">{{ 'ForCarriers' | translate }}</a></li>
          <li class="menu-item mb-3 mb-xl-0"><a class="" routerLinkActive="active" routerLink="/how-it-works">
              {{ 'HowItWorks' | translate }}</a></li>
          <li class="menu-item mb-3 mb-xl-0"><a class="" routerLinkActive="active"
              routerLink="/about">{{ 'AboutUs' | translate }}</a></li>
          <!-- <li class="menu-item mb-3 mb-xl-0"><a class="" routerLinkActive="active"
              routerLink="/contact">{{ 'ContactUs' | translate }}</a>
          </li> -->

          <li class="button-box">
            <div class="mb-1 mb-xl-0" ngbDropdown [placement]="'bottom-left'">
              <button class="btn-lang" id="langDropdown" ngbDropdownToggle>{{selectedLangName}}</button>
              <div ngbDropdownMenu aria-labelledby="langDropdown" class="header__lang-dropdown">
                <span class="up-arrow-drop"></span>
                <ul>
                  <li>
                    <a class="lang-opts" *ngFor="let lang of languages"
                      (click)="onLanguageChange(lang.value)">{{ lang.display }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li  class="button-box">
            <div class="mb-1 mb-xl-0">
              <button class="btn btn-animation btn-register" (click)="goRegister()">
                <span class="arrow">
                  <span></span>
                </span>
                {{ 'BuyerFreeRegister' | translate }}
              </button>
            </div>
          </li>
          <li  class="button-box">
            <div *ngIf="!isPreRegistration">
              <button class="btn btn-sign-in" (click)="goLogin()">{{ 'SignIn' | translate }}</button>
            </div>
          </li>
        </ul>

        <!-- <div class="navbar-btn-box">
        </div> -->
      </div>
    </nav>
  </div>
  
</div>